// src/editorjs/CallToAction.js
export default class CallToAction {
  static get toolbox() {
    return { title: 'CTA', icon: '🧑🏻' };
  }

  constructor({ data }) {
    this.data = {
      mode: data?.mode || 'url', // 'url' | 'booking'
      text: data?.text || 'Demo unverbindlich buchen',
      url: data?.url || 'https://github.com/THEORIGINALBITTER/'
    };

    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this.wrapper.className = 'ce-cta';

    // Mode
    const select = document.createElement('select');
    select.innerHTML = `
      <option value="url">Öffne URL</option>
      <option value="booking">Booking-Modal</option>
    `;
    select.value = this.data.mode;

    // Text
    const inputText = document.createElement('input');
    inputText.type = 'text';
    inputText.placeholder = 'Button-Text';
    inputText.value = this.data.text;
    inputText.className =
      'cta-input border rounded px-2 py-1 my-1 w-full';

    // URL
    const inputUrl = document.createElement('input');
    inputUrl.type = 'url';
    inputUrl.placeholder = 'https://… (nur bei Modus URL)';
    inputUrl.value = this.data.url;
    inputUrl.className =
      'cta-input border rounded px-2 py-1 my-1 w-full';

    select.addEventListener('change', (e) => {
      this.data.mode = e.target.value;
      inputUrl.disabled = this.data.mode !== 'url';
      inputUrl.style.opacity = inputUrl.disabled ? '0.5' : '1';
    });

    inputText.addEventListener('input', (e) => (this.data.text = e.target.value));
    inputUrl.addEventListener('input', (e) => (this.data.url = e.target.value));

    // initial
    inputUrl.disabled = this.data.mode !== 'url';
    if (inputUrl.disabled) inputUrl.style.opacity = '0.5';

    this.wrapper.appendChild(select);
    this.wrapper.appendChild(inputText);
    this.wrapper.appendChild(inputUrl);
    return this.wrapper;
  }

  save() {
    return {
      mode: this.data.mode,
      text: this.data.text,
      url: this.data.url
    };
  }

  static get isReadOnlySupported() {
    return true;
  }
}
